import { SVFilePicker } from '@/components/core';
import { Card, List, ListItem, Stack, Typography } from '@mui/material';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { ExternalAccountFormValues } from '@/types/externalAccounts';

export default function ExternalAccountFormProof() {
  const { control } = useFormContext<ExternalAccountFormValues>();
  const { fields, append, remove } = useFieldArray<ExternalAccountFormValues>({
    control,
    name: 'proofsOfOwnership',
  });

  const proofTypes = [
    'Voided check',
    'Statement',
    "Screenshot of account including the account number, routing number, and owner's names on the account",
  ];

  return (
    <Card>
      <Typography variant="h5" mb={2}>
        External Account Proof
      </Typography>
      <Typography>
        To show proof of ownership, upload a file of one of the following for
        the account entered above:
      </Typography>
      <List sx={{ p: '0', mb: 2 }}>
        {proofTypes.map(rule => (
          <ListItem
            sx={{
              p: '2px 0',
              ml: '30px',
              display: 'list-item',
              listStyleType: 'disc',
            }}
            key={rule}>
            <Typography>{rule}</Typography>
          </ListItem>
        ))}
      </List>
      <Stack sx={{ alignItems: 'flex-start' }} spacing={2}>
        {fields.map((field, index) => (
          <SVFilePicker
            key={field.id}
            name={`proofsOfOwnership.${index}.value`}
            documentDisplayName={`documentDisplayNames.${index}`}
            label="Upload Proof"
            presignedUrlFileType="external bank account"
            acceptedFileTypes=".png,.jpg,.jpeg,.pdf"
            rules={{ required: index === 0 }}
            uuid={null}
            testId={`proofOfOwnership${index + 1}`}
            onRemoveFile={() => remove(index)}
            onUploadSuccess={() => {
              if (index >= 4) {
                return;
              }

              append({ value: '' });
            }}
          />
        ))}
      </Stack>
    </Card>
  );
}
